export const TEAM_REALM = 'TEAM';
export const ACCOUNT_REALM = 'ACCOUNT';

export const TOKEN_REALMS = {
  t: TEAM_REALM,
  a: ACCOUNT_REALM,
};
